type InstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
};

let pendingPrompt: InstallPromptEvent | null = null;
const ADMIN_SW_VERSION = 'admin-20261013-complete-order-items-and-reprints-v10';
let refreshingForUpdate = false;

async function registerAdminServiceWorker() {
  const registration = await navigator.serviceWorker.register(`/storefront-sw.js?v=${ADMIN_SW_VERSION}`, {
    scope: '/',
    updateViaCache: 'none',
  });

  // Chrome puede mantener abierta por varios días una PWA instalada. Esta
  // comprobación obliga a consultar el actualizador sin reutilizar su caché.
  await registration.update();
  if (registration.waiting) registration.waiting.postMessage({ type: 'SKIP_WAITING' });

  registration.addEventListener('updatefound', () => {
    const worker = registration.installing;
    worker?.addEventListener('statechange', () => {
      if (worker.state === 'installed' && navigator.serviceWorker.controller) {
        worker.postMessage({ type: 'SKIP_WAITING' });
      }
    });
  });

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshingForUpdate) return;
    refreshingForUpdate = true;
    window.location.reload();
  });
}

export function initializeAdminPwa() {
  if (window.location.pathname.startsWith('/pedir/') || window.location.pathname.startsWith('/pedir-b2b/')) return;

  let manifest = document.querySelector<HTMLLinkElement>('link[data-fooddash-admin-manifest]');
  if (!manifest) {
    manifest = document.createElement('link');
    manifest.rel = 'manifest';
    manifest.href = '/manifest.webmanifest';
    manifest.dataset.fooddashAdminManifest = 'true';
    document.head.appendChild(manifest);
  }

  if ('serviceWorker' in navigator) {
    void registerAdminServiceWorker().catch(() => undefined);
  }

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    pendingPrompt = event as InstallPromptEvent;
    window.dispatchEvent(new Event('fooddash:install-ready'));
  });
  window.addEventListener('appinstalled', () => {
    pendingPrompt = null;
    window.dispatchEvent(new Event('fooddash:install-finished'));
  });
}

export function adminPwaCanInstall() {
  return Boolean(pendingPrompt) && !window.matchMedia('(display-mode: standalone)').matches;
}

export async function installAdminPwa() {
  if (!pendingPrompt) return false;
  const prompt = pendingPrompt;
  await prompt.prompt();
  const choice = await prompt.userChoice;
  if (choice.outcome === 'accepted') pendingPrompt = null;
  return choice.outcome === 'accepted';
}
